export default __webpack_public_path__ + "static/media/icon-announcement.6240b365.svg";